import { put, takeLatest } from 'redux-saga/effects'
import { UPLOAD_FILE, REMOVE_FILE } from '../modules/files'
import { updateCandidateSuccess } from '../modules/candidate'
import { uploadFile, removeFile } from '../api'

function* uploadFileSaga(action) {
  const response = yield uploadFile(action.payload.file)
  yield put(updateCandidateSuccess(response))
}

function* removeFileSaga(action) {
  const response = yield removeFile(action.payload.id)
  yield put(updateCandidateSuccess(response))
}

export default function* filesSaga() {
  yield takeLatest(UPLOAD_FILE, uploadFileSaga)
  yield takeLatest(REMOVE_FILE, removeFileSaga)
}
